import devices from './devices';

export const NAMESPACE = 'promotionSection';

const customTheme = {
  mediaQueries: {
    tablet: `only screen and ${devices.tablet}`,
    laptop: `only screen and ${devices.laptop}`,
    laptopL: `only screen and ${devices.laptopL}`,
    desktop: `only screen and ${devices.desktop}`,
    desktopL: `only screen and ${devices.desktopL}`,
    // iPhone 5, 5S, SE (1st gen)
    mobileS: `only screen and ${devices.mobileS}`,
    // iPhone 6, 6S, 7, 8, SE (2nd gen)
    mobileM: `only screen and ${devices.mobileM}`,
    // iPhone 6 Plus, 6S Plus, 7 Plus, 8 Plus
    mobileL: `only screen and ${devices.mobileL}`,
    // iPhone X, XS, 11 Pro, 12 mini
    mobileIosNotch: `only screen and (min-height: 812px) and ${devices.mobileM}`,
    // iPhone XR, 11, 12, 13
    mobileIosNotchMax: `only screen and (min-height: 896px) and ${devices.mobileL}`,
    // iPhone SE (3rd gen)
    mobileIosSE3: `only screen and (min-height: 667px) and ${devices.mobileM}`,
    // iPhone 14
    mobileIosNotch14: `only screen and (min-height: 927px) and ${devices.mobileL}`,
  },
};

export default customTheme;
